module.exports = __webpack_public_path__ + "img/GuohuanXie.98c48f4c.jpg";